import * as React from "react";
import { Checkbox, ICheckboxStyles, IStyle } from "@fluentui/react";

interface IProps {
  isOnlyBEO: boolean,
  isLoading: boolean,
  onChange: any

}
interface IState {
  isChecked: boolean,
}
class Experts_Refinement_BEO extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }

  textStyle: IStyle = {
    fontFamily: 'BoschFont',
    fontSize: '16px'
  }

  checkBoxStyle: ICheckboxStyles = {
    text: this.textStyle
  }

  componentDidMount() { }

  render() {
    let element = (
      <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <Checkbox disabled={!!this.props.isLoading} styles={this.checkBoxStyle} checked={this.props.isOnlyBEO} label="BEO Only" onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, isChecked?: boolean) => {
              this.setState({
                isChecked: !!isChecked
              }, () => {
                this.props.onChange(this.state.isChecked)
              })
            }} />
          </div>
        </div>
      </div>
    );
    return element;
  }
}
export default Experts_Refinement_BEO;
